export class BookSelfAssignController {
	
	public availableBooks:Array<any>;
	public isLoading=true;
	public longLoadCheckCount=0;
	
	// @ngInject
	constructor(
		private $window,
		private $sce,
		private $timeout,
		private bookService,
		private licenseService
	) {}	
	
	public $onInit = () => {
		
		this.initLoadTimeWatcher();
		
		this.bookService.getAvailableBooks().then(
			(response)=>{
				this.availableBooks = response;
			}
		).finally(()=>{
			this.isLoading=false;
		})	
	}
	
	public initLoadTimeWatcher = () => {
		if(!this.isLoading){
			return;
		}
		this.longLoadCheckCount++;
		this.$timeout(()=>{
			this.initLoadTimeWatcher();
		}, 1000)
	}
	
	public submit = () =>{ 
		
		var formData = {
			'bookIDList': ''
		}; 
		
		for(var i=0; i<this.availableBooks.length; i++){
			
			if(this.availableBooks[i].assignStudentLicense){
				formData['bookIDList'] += this.availableBooks[i]['studentEdition']['bookID'] + ',';
			}
			
			if(this.availableBooks[i].assignTeacherLicense){
				formData['bookIDList'] += this.availableBooks[i]['teacherEdition']['bookID'] + ',';
			}
			
		}	
		
		formData['bookIDList'] = formData['bookIDList'].slice(0, -1);
		
		this.licenseService.selfAssignBooks(formData).then(
			(response)=>{
				this.$window.location.href = '/books/';
			}	
		)
	} 
}